import { IFormMarketShare } from 'legacy/lut/classes/models/partner360/IFormMarketShare'

export const getGtmPoints = (
  marketShareData: IFormMarketShare[],
  fieldValue: number,
  year: number,
  type: 'Online' | 'Instore'
) => {
  let gtmOnlinePercentage = 0
  let gtmInstorePercentage = 100

  const currentMarketShare = marketShareData.filter((el) => el.FYear === year)
  if (currentMarketShare.length) {
    gtmOnlinePercentage = currentMarketShare[0].PercentageValue || 0
    gtmInstorePercentage = 100 - gtmOnlinePercentage
  }
  const percentage = type === 'Online' ? gtmOnlinePercentage : gtmInstorePercentage
  const gtmValue = ((fieldValue || 0) * percentage) / 100

  return gtmValue
}
